import GeometryBase from "./geo-base";

class GeometryDodecahedron extends GeometryBase {
    constructor(canvasSize) {
        const s1 = Math.sin(2 * Math.PI / 5), s2 = Math.sin(4 * Math.PI / 5);
        const c1 = Math.cos(2 * Math.PI / 5), c2 = Math.cos(Math.PI / 5);

        /**
         *          N
         *        /   \
         *      /       \
         *     W         E
         *      \        /
         *       \      /
         *        SW__SE
         */

        const v_N = new THREE.Vector3((0.0 + 1.0) / 2.0, (1.0 + 1.0) / 2.0);
        const v_W = new THREE.Vector3((-s1 + 1.0) / 2.0, (+c1 + 1.0) / 2.0);
        const vSW = new THREE.Vector3((-s2 + 1.0) / 2.0, (-c2 + 1.0) / 2.0);
        const vSE = new THREE.Vector3((+s2 + 1.0) / 2.0, (-c2 + 1.0) / 2.0);
        const v_E = new THREE.Vector3((+s1 + 1.0) / 2.0, (+c1 + 1.0) / 2.0);

        GeometryDodecahedron.pairs = GeometryDodecahedron.pairs || [
            [new THREE.Line3(v_N, v_W), new THREE.Line3(v_N, v_E)],
            [new THREE.Line3(v_W, vSW), new THREE.Line3(v_E, vSE)]
        ];

        GeometryDodecahedron.additionalPairs = GeometryDodecahedron.additionalPairs || [
            new THREE.Line3(vSW, vSE)
        ];

        GeometryDodecahedron.indices = GeometryDodecahedron.indices || [
            [[0x0e, 0x0b, 0x03], [0x0b, 0x0e, 0x0f], [0x0b, 0x0f, 0x07]],   // 0x0
            [[0x05, 0x07, 0x0f], [0x07, 0x05, 0x12], [0x07, 0x12, 0x13]],   // 0x1
            [[0x12, 0x06, 0x13], [0x06, 0x12, 0x04], [0x06, 0x04, 0x0d]],   // 0x2
            [[0x04, 0x0c, 0x0d], [0x0c, 0x04, 0x08], [0x0c, 0x08, 0x00]],   // 0x3
            [[0x08, 0x10, 0x00], [0x10, 0x08, 0x09], [0x10, 0x09, 0x01]],   // 0x4
            [[0x10, 0x03, 0x11], [0x03, 0x10, 0x01], [0x03, 0x01, 0x0e]],   // 0x5
            [[0x00, 0x02, 0x0c], [0x02, 0x00, 0x10], [0x02, 0x10, 0x11]],   // 0x6
            [[0x01, 0x0f, 0x0e], [0x0f, 0x01, 0x09], [0x0f, 0x09, 0x05]],   // 0x7
            [[0x09, 0x12, 0x05], [0x12, 0x09, 0x08], [0x12, 0x08, 0x04]],   // 0x8
            [[0x07, 0x0a, 0x0b], [0x0a, 0x07, 0x13], [0x0a, 0x13, 0x06]],   // 0x9
            [[0x0d, 0x0a, 0x06], [0x0a, 0x0d, 0x0c], [0x0a, 0x0c, 0x02]],   // 0xa
            [[0x02, 0x0b, 0x0a], [0x0b, 0x02, 0x11], [0x0b, 0x11, 0x03]]    // 0xb
        ];

        const phi = (1 + Math.sqrt(5)) * 0.5, phi2 = phi ** 2, unit = 1 / (phi2 * 2);

        GeometryDodecahedron.vertices = GeometryDodecahedron.vertices || new Array(
            // orange
            new THREE.Vector3(-phi, -phi, -phi).multiplyScalar(unit),    // 0x00
            new THREE.Vector3(-phi, -phi, +phi).multiplyScalar(unit),    // 0x01
            new THREE.Vector3(-phi, +phi, -phi).multiplyScalar(unit),    // 0x02
            new THREE.Vector3(-phi, +phi, +phi).multiplyScalar(unit),    // 0x03
            new THREE.Vector3(+phi, -phi, -phi).multiplyScalar(unit),    // 0x04
            new THREE.Vector3(+phi, -phi, +phi).multiplyScalar(unit),    // 0x05
            new THREE.Vector3(+phi, +phi, -phi).multiplyScalar(unit),    // 0x06
            new THREE.Vector3(+phi, +phi, +phi).multiplyScalar(unit),    // 0x07

            // green
            new THREE.Vector3(0.0, -phi2, -1.0).multiplyScalar(unit),    // 0x08
            new THREE.Vector3(0.0, -phi2, +1.0).multiplyScalar(unit),    // 0x09
            new THREE.Vector3(0.0, +phi2, -1.0).multiplyScalar(unit),    // 0x0a
            new THREE.Vector3(0.0, +phi2, +1.0).multiplyScalar(unit),    // 0x0b

            // blue
            new THREE.Vector3(-1.0, 0.0, -phi2).multiplyScalar(unit),    // 0x0c
            new THREE.Vector3(+1.0, 0.0, -phi2).multiplyScalar(unit),    // 0x0d
            new THREE.Vector3(-1.0, 0.0, +phi2).multiplyScalar(unit),    // 0x0e
            new THREE.Vector3(+1.0, 0.0, +phi2).multiplyScalar(unit),    // 0x0f

            // pink
            new THREE.Vector3(-phi2, -1.0, 0.0).multiplyScalar(unit),    // 0x10
            new THREE.Vector3(-phi2, +1.0, 0.0).multiplyScalar(unit),    // 0x11
            new THREE.Vector3(+phi2, -1.0, 0.0).multiplyScalar(unit),    // 0x12
            new THREE.Vector3(+phi2, +1.0, 0.0).multiplyScalar(unit)     // 0x13

        );

        GeometryDodecahedron.attrIndices = GeometryDodecahedron.attrIndices || new THREE.Uint8BufferAttribute([0, 1, 2, 3, 4, 5, 6, 7, 8], 1);
        GeometryDodecahedron.attrUv = GeometryDodecahedron.attrUv || new THREE.Float32BufferAttribute([
            vSW.x, vSW.y,
            v_N.x, v_N.y,
            v_W.x, v_W.y,

            v_N.x, v_N.y,
            vSW.x, vSW.y,
            vSE.x, vSE.y,

            v_N.x, v_N.y,
            vSE.x, vSE.y,
            v_E.x, v_E.y
        ], 2);

        super(canvasSize);
    }
}

export default GeometryDodecahedron;
export { GeometryDodecahedron };